import React from 'react';

import {
  NavigationMenuContent,
  NavigationMenuItem,
} from '@sandtech-hub-monorepo/ui-kit';

import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu';

import { AppItem } from './AppItem';
import { DotsGridIcon } from '@sandtech-hub-monorepo/ui-kit-site';
import { APPS_MENU_ITEM_VALUE } from '../utils';

export interface AppsCenterProps {
  className?: string;
  apps: {
    name: string;
    displayName: string;
    iconName: string;
    route: string;
    openCheckInModal: boolean;
    openInNewTab?: boolean;
  }[];
  sdk: boolean;
}

export const AppsCenter = ({ className, apps, sdk }: AppsCenterProps) => {
  return (
    <NavigationMenuItem className={className} value={APPS_MENU_ITEM_VALUE}>
      <NavigationMenuPrimitive.Trigger
        onPointerMove={(event) => event.preventDefault()}
        onPointerLeave={(event) => event.preventDefault()}
      >
        <DotsGridIcon className="[&_path]:stroke-current" />
      </NavigationMenuPrimitive.Trigger>
      <NavigationMenuContent
        className="w-[calc(100vw-3rem)] xs:w-[400px] md:w-[400px]"
        onPointerMove={(event) => event.preventDefault()}
        onPointerLeave={(event) => event.preventDefault()}
      >
        <ul className="w-full grid gap-8 p-4 py-8 grid-cols-3">
          {apps.map((app) => (
            <AppItem
              sdk={sdk}
              name={app.name}
              displayName={app.displayName}
              iconName={app.iconName}
              key={app.name}
              route={app.route}
              openCheckInModal={app.openCheckInModal}
              openInNewTab={app.openInNewTab}
            />
          ))}
        </ul>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};
